import {
  VuexModule, Module, Action,
} from 'vuex-module-decorators';
import Vue from 'vue';
import {
  RESULT_SPADE_GAMING_URL,
  M_POST,
  GET_RESULT,
} from '@/utils/api';

@Module({ name: 'Result' })
export default class Result extends VuexModule {
  @Action
  async fetchResult(body: any) {
    return Vue.axios({
      url: RESULT_SPADE_GAMING_URL + GET_RESULT,
      headers: {
        Authorization: `Bearer ${body.token}`,
      },
      data: body.params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { status } = data;
        if (status.code) throw status;
        else {
          return data.data;
        }
      })
      .catch((err: string) => err);
  }
}
